// =============================================================================
// useDebounce Hook - Debounce di valori reattivi
// =============================================================================

import { useState, useEffect } from 'react';

/**
 * Hook che ritorna il valore solo dopo che è rimasto stabile per `delay` ms.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
